import React from 'react';

export default function BookingSuccessModal({ successData, onClose }) {
    if (!successData || !successData.message) return null;
    
    return (
        <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-[200] p-4 animate-fade-in">
            <div className="bg-white rounded-3xl shadow-2xl max-w-sm w-full overflow-hidden transform transition-all scale-100 p-6 text-center">
                <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4 shadow-inner">
                    <span className="text-4xl">🎉</span>
                </div>
                <h2 className="text-2xl font-bold mb-2 text-gray-900">Request Sent!</h2>
                <p className="text-gray-600 mb-6 text-sm leading-relaxed">{successData.message}</p>
                
                {successData.bookingNumber && (
                    <div className="bg-gray-50 border border-gray-100 rounded-2xl p-4 mb-6">
                        <p className="text-xs text-gray-500 font-bold uppercase tracking-wider mb-1">Your Booking Number</p>
                        <p className="text-2xl font-mono font-black text-pink-600 tracking-widest">{successData.bookingNumber}</p>
                    </div>
                )}
                
                {successData.showCreateAccount && (
                    <p className="text-xs text-gray-400 mb-6 italic">
                        You can create an account later to easily manage this and future bookings.
                    </p>
                )}
                
                <button onClick={onClose} className="w-full bg-gray-900 text-white py-3 rounded-xl font-bold hover:bg-gray-800 transition-colors shadow-md">
                    Done
                </button>
            </div>
        </div>
    );
}